import { combineReducers } from 'redux';

import { apiSlice } from '@api/apiSlice';
import { bonusServiceApiSlice } from '@api/bonusServiceApiSlice';
import {
  playerReportingBonusApiSlice,
  playerReportingBonusServiceApiSlice,
} from '@api/createPlayerReportingApi';
import { playerReportingServiceApiSlice } from '@api/playerReportingServiceApiSlice';
import authReducer from '@features/auth/store/authSlice';
import customizeTableReducer from '@features/customizeTable/store/customizeTableSlice';
import menuReducer from '@features/menu/menuSlice';
import timelineSlice from '@features/timeline/store/timelineSlice';
import campaignsSlice from '@modules/automaticCampaigns/store/automaticCampaignsSlice';
import bonusesPendingReviewSlice from '@modules/bonusesPendingReviewReport/store/bonusesPendingReviewSlice';
import bonusesSlice from '@modules/bonusManagement/store/bonusesSlice';
import campaignActivitySlice from '@modules/campaignActivityReport/store/campaignActivitySlice';
import campaignMonitorSlice from '@modules/campaignMonitorReport/store/campaignMonitorSlice';
import codeCampaignsSlice from '@modules/codeCampaigns/store/codeCampaignsSlice';
import accumulatedTriggerConditionsSlice from '@modules/common/accumulatedTriggerConditions/store/accumulatedTriggerConditionsSlice';
import campaignVisibilitySlice from '@modules/common/campaignVisibility/store/campaignVisibilitySlice';
import casinoGamesSlice from '@modules/common/casinoConditions/store/casinoGamesSlice';
import sportsDataSlice from '@modules/common/sportsData/store/sportsDataSlice';
import contributionBetsReportSlice from '@modules/contributionBetsReport/store/contributionBetsReportSlice';
import playerBonusesSlice from '@modules/playerBonuses/store/playerBonusesSlice';
import playerCampaignsSlice from '@modules/playerCampaigns/store/playerCampaignsSlice';
import playerCodesSlice from '@modules/playerCodes/store/playerCodesSlice';
import playerOffersSlice from '@modules/playerOffers/store/playerOffersSlice';
import ruleEngineSlice from '@modules/ruleEngine/store/ruleEngineSlice';
import scheduledCampaignsSlice from '@modules/scheduledCampaigns/store/scheduledCampaignsSlice';
import appConfigSlice from '@store/appConfig/appConfigSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  menu: menuReducer,
  timeline: timelineSlice,
  appConfig: appConfigSlice,
  bonusesModule: bonusesSlice,
  sportsData: sportsDataSlice,
  ruleEngine: ruleEngineSlice,
  casinoGames: casinoGamesSlice,
  playerCodes: playerCodesSlice,
  playerOffers: playerOffersSlice,
  playerBonuses: playerBonusesSlice,
  codeCampaigns: codeCampaignsSlice,
  automaticCampaigns: campaignsSlice,
  playerCampaigns: playerCampaignsSlice,
  customizeTable: customizeTableReducer,
  campaignMonitor: campaignMonitorSlice,
  campaignActivity: campaignActivitySlice,
  [apiSlice.reducerPath]: apiSlice.reducer,
  campaignVisibility: campaignVisibilitySlice,
  scheduledCampaigns: scheduledCampaignsSlice,
  bonusesPendingReview: bonusesPendingReviewSlice,
  contributionBetsReport: contributionBetsReportSlice,
  accumulatedTriggerConditions: accumulatedTriggerConditionsSlice,
  [bonusServiceApiSlice.reducerPath]: bonusServiceApiSlice.reducer,
  [playerReportingBonusApiSlice.reducerPath]:
    playerReportingBonusApiSlice.reducer,
  [playerReportingServiceApiSlice.reducerPath]:
    playerReportingServiceApiSlice.reducer,
  [playerReportingBonusServiceApiSlice.reducerPath]:
    playerReportingBonusServiceApiSlice.reducer,
});

export default rootReducer;
